import { memo, useMemo } from 'react'
import { Box, SxProps, Theme } from '@mui/material'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { primary } from '../../assets/colors'
import { indicativePriceRaw } from '../../util/indicativePrice'
import { NonInteractiveTooltip } from '../custom'

type IndicativePriceIconProps = {
    securityKey?: string
    securityKeys?: string[]
    sx?: SxProps<Theme>
}

const IndicativePriceIcon = ({ securityKey, securityKeys, sx }: IndicativePriceIconProps) => {
    const keysKey = securityKeys?.join('\0') ?? ''
    const keys = useMemo(() => {
        if (securityKeys?.length) return securityKeys
        return securityKey ? [securityKey] : []
    }, [securityKey, keysKey])

    const active = useSelector((state: RootState) => {
        for (const key of keys) {
            if (indicativePriceRaw(state.securityStore.orderBooks[key]) != null) return true
        }
        return false
    })

    if (!active) return null

    return (
        <NonInteractiveTooltip title="Indicative price" arrow placement="top">
            <Box
                component="span"
                aria-label="Indicative price"
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 8,
                    height: 8,
                    flexShrink: 0,
                    ...((sx as object) ?? {}),
                }}
            >
                <Box
                    sx={{
                        width: 6,
                        height: 6,
                        borderRadius: '50%',
                        backgroundColor: primary,
                    }}
                />
            </Box>
        </NonInteractiveTooltip>
    )
}

export default memo(IndicativePriceIcon)
